'use client';

import { ReactNode } from 'react';
import { ButtonBase, DrawerTriggerButton } from '../../common';
import {
  CryptoTransfersTransactionsAssetType,
  CryptoTransfersTransactionsExternalAddressType,
  CryptoTransfersTransactionsItemType,
} from '../types';
import { SelfDeclarationDepositDrawer } from '../../crypto-transfers/components/SelfDeclarationDepositDrawer/SelfDeclarationDepositDrawer';
import { TransferNetworkDataType } from '../../crypto-transfers/utils/useTransfersNextStepState.client';
import { useUserAccessControl } from '../../common/utils/userAccess';
import { timeScalarOrNull } from '@bts-web/utils-formatting';

export interface VerifyWalletButtonProps {
  children: ReactNode;
  transaction: CryptoTransfersTransactionsItemType;
}

export const VerifyWalletButton = ({
  transaction,
  children,
}: VerifyWalletButtonProps) => {
  const { isPepFailed } = useUserAccessControl();

  if (isPepFailed) {
    return null;
  }

  return (
    <DrawerTriggerButton
      DrawerComponent={SelfDeclarationDepositDrawer}
      drawerProps={{
        cryptoTransferData: {
          assetData: transaction?.asset as CryptoTransfersTransactionsAssetType,
          networkData: transaction?.network as TransferNetworkDataType,
          externalAddress:
            transaction?.externalAddress as CryptoTransfersTransactionsExternalAddressType,
          createdAt: timeScalarOrNull(transaction?.createdAt),
          assetAmount: transaction?.assetAmount,
        },
      }}
    >
      <ButtonBase size="large" visual="primary">
        {children}
      </ButtonBase>
    </DrawerTriggerButton>
  );
};
